import {
  TStateCommunications,
  createStateSagaCommunications,
} from 'src/helpers/redux'
import { actions as sagaActions, PREFIX } from './actions'
import { IGlobalStore } from 'src/types/store'
import * as notificationTypes from 'src/services/notifications/types'

export interface IStateData {
  notifications: {
    items: notificationTypes.IGetNotificationsData
    nextCursor?: string
  }
  notificationsCount?: number
}

export interface IState {
  communication: TStateCommunications<typeof sagaActions>
  data: IStateData
}

export const initialState: IState = {
  communication: createStateSagaCommunications(sagaActions),
  data: {
    notifications: {
      items: [],
      nextCursor: undefined,
    },
    notificationsCount: undefined,
  },
}

export type TGlobalStateWithService = IGlobalStore & {
  [PREFIX]: IState
}

export { PREFIX }
